import { useContext, useState } from 'react';
import Link from 'next/link';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCheckout } from '@/context/checkoutProvider';
import { UrlHistory } from '@/context/historyTrackerProvider';
import { useCart } from '@/frontastic';
import { CurrencyHelpers } from '@/helpers/utils/currencyHelpers';
import { PathNames, getSelectedDivision, TranslateText } from '@/helpers/utils/siteUtils';
import { DEFAULT_SITE_LANG, ORDER_TYPES } from '../../../../../../constants/constant';
import { addFromOrderParam } from '../../../order-details/util';
import { Button } from '../../../ui/button';
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '../../../ui/card';
import Loader from '../../../ui/loader';
import { PageTexts } from '../../i18n';

const CustomerOrderSummary = ({ showButton, data }: { showButton: boolean; data: any }) => {
  const Texts = TranslateText(PageTexts, DEFAULT_SITE_LANG);
  const { updatePageName } = useContext(UrlHistory);
  const { resetContextValues } = useCheckout();
  const { resetCart } = useCart(false);
  const router = useRouter();
  const params = useSearchParams();
  const fromOrderDetails = params.get('fromOrder') ?? false;
  const [loading, setLoading] = useState(false);

  const createNewOrder = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    resetContextValues();
    const divisionCode = getSelectedDivision() ?? 'ZB';
    await resetCart({
      orderType: ORDER_TYPES.NEW_ORDER,
      omsCustomerId: data?.omsCustomerId,
      divisionCode: divisionCode,
    });
    updatePageName(Texts.createNewOrder, PathNames.SEARCH);
    if (fromOrderDetails) {
      const url = addFromOrderParam('/search');
      router.push(url);
    } else {
      router.push('/search');
    }
    setLoading(false);
  };

  return (
    <Card className="rounded-md border-[1px] border-foggyGray bg-lightSilver shadow-lg">
      {loading && <Loader />}
      <CardHeader className="px-5 ">
        <CardTitle className="pt-1.5 text-lg font-bold">{Texts.orderSummary}</CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2">
        <section className="flex text-base font-normal">
          <p className="mr-auto">{Texts.orderTotal}: </p>
          {showButton && data?.lineItems?.length > 0 ? (
            <p>{CurrencyHelpers.customCurrencyFormat(data?.totalPrice ?? { centAmount: 0 })}</p>
          ) : (
            <p>{CurrencyHelpers.customCurrencyFormat({ centAmount: 0 })}</p>
          )}
        </section>
      </CardContent>
      <CardFooter className="mt-3.5">
        {showButton && data?.lineItems?.length > 0 ? (
          <Button className="mb-1 w-full bg-deepBlue py-8 text-xl font-bold text-white">
            <Link href={'/cart'}>{Texts.checkOut}</Link>
          </Button>
        ) : (
          <Button className="mb-1 w-full bg-deepBlue py-8 text-xl font-bold text-white">
            <Link href={'/search'} onClick={(e) => createNewOrder(e)}>
              {Texts.createNewOrder}
            </Link>
          </Button>
        )}
      </CardFooter>
    </Card>
  );
};

export default CustomerOrderSummary;
